import classNames from 'classnames/bind';
import styles from './Notice.module.scss';

const cx = classNames.bind(styles);

export function Notice() {
  return (
    <div class={cx('container')}>
      <h2 class={cx('title')}>회원 코드 안내 </h2>

      <div class={cx('para')}>
        <span class={cx('number')}>1</span>{' '}
        <span class={cx('text')}>게임 실행하고 로비 좌측 프로필 터치하기</span>
      </div>

      <div class={cx('detail', 'detail-1')} />

      <div class={cx('para')}>
        <span class={cx('number')}>2</span>{' '}
        <span class={cx('text')}>계정 정보 및 회원 코드 복사하기</span>
      </div>

      <div class={cx('detail', 'detail-2')} />

      <ul class={cx('list')}>
        <li>
          ※ 쿠폰/퀴즈 보상은 선물함으로 지급됩니다. (단, 일부 보상은 즉시 지급)
        </li>
        <li>※ 쿠폰/퀴즈는 사용기간과 사용 제한 횟수가 있습니다.</li>
        <li>※ 쿠폰/퀴즈 보상은 환불이 불가능합니다.</li>
        <li>※ 쿠폰/퀴즈 보상 선물 지급까지 시간이 걸릴 수 있습니다.</li>
        <li>※ 보상 미지급 시에는 잠시 후 선물함을 다시 확인해 주세요.</li>
        <li>※ 보상이 지급되지 않을 경우 고객센터로 문의 바랍니다.</li>
        <li>
          ※ 회원코드가 없는 경우 MOB 또는 PC 뉴맞고의{' '}
          <strong>설정 &gt; 쿠폰입력</strong>에서 쿠폰 사용이 가능합니다.
        </li>
      </ul>
    </div>
  );
}
